module.exports = __webpack_public_path__ + "img/art__interior.69890038.svg";